export default __webpack_public_path__ + "static/media/miguel-lopes-41.f5482cc9.jpg";